export default __webpack_public_path__ + "static/media/ic-holidays.3939f726.svg";